function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8 8.93335C17.8032 10.1652 17.5154 11.3804 16.96 12.48C16.3014 13.7976 15.2891 14.9059 14.0363 15.6807C12.7835 16.4554 11.3397 16.8661 9.86665 16.8667C8.63478 16.8699 7.41956 16.5821 6.31999 16.0267L1 17.8L2.77333 12.48C2.21793 11.3804 1.93012 10.1652 1.93333 8.93335C1.9339 7.46032 2.34457 6.01655 3.11933 4.76373C3.8941 3.51092 5.00236 2.49855 6.31999 1.84003C7.41956 1.28463 8.63478 0.996815 9.86665 1.00003H10.3333C12.2787 1.10735 14.1162 1.92847 15.4938 3.30616C16.8715 4.68385 17.6926 6.52129 17.8 8.46668V8.93335Z",
  stroke: "#147DB9",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCommentIcon = function SvgCommentIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommentIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CommentIcon.10ed8dff.svg";
export { ForwardRef as ReactComponent };